import Modal from "components/common/Modal";
import React, { useEffect, useRef, useState } from "react";
import "./ValidationModal.scoped.scss";

interface IAddSWConfirmationModal {
    saveData(versionChanges: string): void,
    header: string,
    message: string,
    existingText?: string
}

const ValidationModal: React.FC<IAddSWConfirmationModal> = (props) => {
    const [textBox, setTextBox] = useState(props.existingText || "");
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        autoResizeTextArea();
    }, [textBox]);

    const autoResizeTextArea = () => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = "auto";
            textAreaRef.current.style.height = Math.min(textAreaRef.current.scrollHeight, 400) + "px";
        }
    };

    return (
        <Modal
            header={props.header}
            controls={(
                <>
                    <div>
                        <textarea
                            ref={textAreaRef}
                            className="txtCls"
                            value={textBox}
                            onChange={(e) => { setTextBox(e.target.value) }}
                            rows={3}
                        />
                    </div>
                    <div>

                    </div>
                    <div className="btnCls">
                        <button
                            className="primary-button ok-button"
                            disabled={textBox === ""}
                            onClick={() => { props.saveData(textBox) }}
                        >
                            Continue to submit for review
                        </button>
                    </div>
                </>
            )}
            isOpen={true}
        >
            <p>
                {props.message}
            </p>
        </Modal>
    );
};

export default ValidationModal;